import React, { useState } from "react";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import withIntl from "../../utils/withIntl";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import TextFieldForms from "../Forms/TextFieldForms";
import InputAdornment from "@material-ui/core/InputAdornment";
import ChangeAmountButtons from "./ChangeAmountButtons";
import Divider from "@material-ui/core/Divider";
import SelectArticles from "../Forms/SelectArticles";
import articlesStore from "../../store/articles/ArticlesStore";
import { Checkbox, FormControlLabel } from "@material-ui/core";

const useStyles = makeStyles({
  textFieldContainer: {
    display: "flex",
    flexDirection: "column",
    margin: 10,
  },
  label: { width: "100%" },
  input: { width: "100%" },
});

function AmountButtonSettings(props) {
  const classes = useStyles();
  const [noLimit, setNoLimit] = useState(props.setting?.initial_max == null);
  let buttonUnit;

  switch (props.type) {
    case "ordergroup_limit":
      buttonUnit = "ordergroups";
      break;
    case "time_limit":
      buttonUnit = "minutes";
      break;
    default:
      buttonUnit = "units";
  }

  const setting = props.setting ?? { buttons: [], initial_max: 180 };
  if (!setting.buttons) {
    setting.buttons = [];
  }

  return (
    <div className={classes.textFieldContainer}>
      <div className={classes.label}>
        <Typography style={{ fontWeight: 600 }}>{props.intl.formatMessage({ id: props.label })}</Typography>
        <Typography variant="caption" style={{ color: "gray" }}>
          {props.helperTextLabel ?? ""}
        </Typography>
      </div>
      <div className={classes.input}>
        <FormControlLabel
          label={"No limit"}
          control={
            <Checkbox
              checked={noLimit}
              onChange={(e) => {
                setNoLimit(e.target.checked);
                if (e.target.checked) {
                  delete setting.initial_max;
                  props.onChangeFields(setting);
                } else {
                  props.onChangeFields(setting);
                }
              }}
            />
          }
        />
        {!noLimit && (
          <>
            <TextFieldForms
              type={"number"}
              label={"Maximum"}
              value={setting.initial_max}
              onChange={(event) => {
                let newValue = { ...setting, initial_max: parseInt(event.target.value) };
                props.onChangeFields(newValue);
              }}
            />
            <SelectArticles
              filteredOutArticles={setting.buttons?.map((button) => button.m_article_id)}
              label={props.intl.formatMessage({ id: "add_set_buttons" })}
              handleOnSelect={(article) => {
                let newButton = { [buttonUnit]: 5, m_article_id: article.id };
                props.updateButtons(newButton);
              }}
              value={props.value}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <AddCircleIcon color={"primary"} />
                  </InputAdornment>
                ),
              }}
            />
            {setting.buttons?.map((button) => (
              <ChangeAmountButtons
                label={articlesStore.articles[button.m_article_id]?.name}
                value={button[Object.keys(button).find((key) => key !== "m_article_id")]}
                setValue={(value) => {
                  let newButton = { [buttonUnit]: value, m_article_id: button.m_article_id };
                  props.updateButtons(newButton);
                }}
                onDelete={() => props.updateButtons(button, "removed")}
                button={button}
              />
            ))}
          </>
        )}
        <Divider style={{ marginTop: "8px", marginBottom: "8px" }} />
      </div>
    </div>
  );
}

export default withIntl(AmountButtonSettings);
